import { Component, Input, EventEmitter, Output } from "@angular/core";
import { toDescriptor } from "@qqcw/qqsystem-util";
import { Vehicle } from "src/app/core/services/myqq";
import { getMakeModelFromMakeIdModel } from "src/lib/util";
import { sortBy as _sortBy } from "lodash-es";
import { displayVehiclePlate } from "src/app/shared/pipes/display-vehicle-plate.pipe";

@Component({
  selector: "myqq-confirm-account-linking",
  templateUrl: "./confirm-account-linking.component.html",
  styleUrls: ["./confirm-account-linking.component.scss"],
})
export class ConfirmAccountLinkingComponent {
  @Input("vehicles") set _vehicles(vehicles: Vehicle[]) {
    this.vehicles = _sortBy(vehicles, [
      ({ hasMembership }) => !hasMembership,
      displayVehiclePlate,
    ]);
  }
  @Input() washLevelName: string;

  @Output()
  userDeclinesLink = new EventEmitter();

  @Output()
  userConfirmsLink = new EventEmitter();

  readonly toDescriptor = toDescriptor;
  vehicles: Vehicle[];

  confirm() {
    this.userConfirmsLink.emit();
  }

  cancel() {
    this.userDeclinesLink.emit();
  }

  readonly toMakeModel = ({ year, make, model, color }: Vehicle) =>
    [year, color, ...getMakeModelFromMakeIdModel(make, model)]
      .filter(Boolean)
      .join(" ");
}
